export default __webpack_public_path__ + "static/media/burger.e78eec97.svg";